import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiMail, FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMailBulk, FaStar } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';
import { Form } from '@unform/web';
import Input from 'src/pages/DashboardPages/core/components/Forms/Input';
import SelectSimple from 'src/pages/DashboardPages/core/components/Forms/SelectSimple';


interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();


  const sendMail = async (data) => {
    addLoading({ title: 'Carregando', key: 'loading' })
    try {
      await api.post(`send-invitation-to-sponsors/${lineData?.hash}`, { ...data })

      removeLoading('loading');
      addToast({ title: 'Enviado com sucesso', type: 'success' });
      removeModal('modal')

    }
    catch (err) {
      addToast({ title: err?.response?.data?.message || 'Erro ao enviar', type: 'error' });
      removeLoading('loading');
    }

  }


  const sendMailCheck = () => {

    addModal({
      title: '', key: 'modal', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '#333', width: '100%', textAlign: 'center' }}>Confirmar envio?</h2>

        <Form onSubmit={sendMail} initialData={{ quantity: 1, category_id: 'Patrocinador' }}>
          <h2 style={{ color: '#333', margin: '10px auto' }}>Campos obrigatórios</h2>
          <Input name="category_id" placeholder="Categoria" />
          <Input name="company" placeholder="Empresa" />
          <Input name="email" placeholder="E-mail" />
          <SelectSimple options={[
            { label: '1', value: '1' },
            { label: '2', value: '2' },
            { label: '3', value: '3' },
            { label: '4', value: '4' },
            { label: '5', value: '5' },
            { label: '6', value: '6' },
            { label: '7', value: '7' },
            { label: '8', value: '8' },
            { label: '9', value: '9' },
            { label: '10', value: '10' },
            { label: '11', value: '11' },
            { label: '12', value: '12' },
            { label: '13', value: '13' },
            { label: '14', value: '14' },
            { label: '15', value: '15' },
            { label: '16', value: '16' },
            { label: '17', value: '17' },
            { label: '18', value: '18' },
            { label: '19', value: '19' },
            { label: '20', value: '20' },
            { label: '21', value: '21' },
            { label: '22', value: '22' },
            { label: '23', value: '23' },
            { label: '24', value: '24' },
            { label: '25', value: '25' },
            { label: '26', value: '26' },
            { label: '27', value: '27' },
            { label: '28', value: '28' },
            { label: '29', value: '29' },
            { label: '30', value: '30' },
          ]} name="quantity" label='Quantidade de convites' />

          <Input name="name" placeholder="Nome" />


          <h2 style={{ color: '#333', margin: '10px auto' }}>Campos não obrigatórios</h2>

          <Input name="phone" placeholder="Telefone" />
          <Input name="document_number" placeholder="CPF" />


          <Input name="position" placeholder="Cargo" />
          <button className='greenButton2' style={{ margin: '10px auto' }}  >Criar</button>

        </Form>

      </>
    })

  }




  const moduleUpdate = (data: Record<string, any>): JSX.Element => (
    <>
      <button className='lineIcon' title='Criar Patrocinador' onClick={() => { sendMailCheck() }}><FaStar /></button>


    </>
  );

  return moduleUpdate(lineData);
}
